module.exports = __webpack_public_path__ + "media/site/images/products/saas_actionplan-bc13a7e320a057ef2fc99e4274e7ae7c.png";